import { z } from "zod";
import {
  // Basic Info
  SCHOOL_NAME,
  STATE,
  CITY,
  ZIP,
  REGION,
  PHONE,
  EMAIL,
  WEBSITE,
  SCHOOL_LOGO,
  ADDRESS1,
  ADDRESS2,
  // Academic and operational info
  YEARS_OF_COLLABORATION,
  GRADES_SELECTED,
  FACULTY_DAYS,
  EDUCATOR_TYPE,
  MAINTENANCE,
  SKU,
  NO_OF_WORKSTATIONS,
  INCLUDES_BOOKS,
  SCHOOL_TIER,
  SYLLABUS,
  NO_FACULTY_DAYS,
  ACCOUNT_TYPE,
  STUDENT_STRENGTH
} from "./consts";

export const schema = z.object({
  // Basic Info
  [SCHOOL_NAME]: z.string().min(3, "This field is required"),
  [STATE]: z.string().min(1, "This field is required"),
  [CITY]: z.string().min(1, "This field is required"),
  [ZIP]: z.string().regex(/^[1-9][0-9]{5}$/, "Invalid Zipcode"),
  [REGION]: z.string().optional(),
  [PHONE]: z
    .string()
    .min(10, "This field is required")
    .regex(/^[0-9]{10}$/, "Invalid Phone Number"),
  [EMAIL]: z
    .string()
    .min(1, "Please fill contact email")
    .email("This is not a valid email."),
  [WEBSITE]: z.string().optional(),
  [SCHOOL_LOGO]: z.any().optional(),
  [ADDRESS1]: z.string().min(3, "This field is required"),
  [ADDRESS2]: z.string().optional(),

  // Academic and operational info
  [YEARS_OF_COLLABORATION]: z.string().min(1, "This field is required"),
  [GRADES_SELECTED]: z.array(z.string()).min(1, "This field is required"),
  [FACULTY_DAYS]: z.array(z.string()).optional(),
  [NO_FACULTY_DAYS]: z.string().optional(),
  [EDUCATOR_TYPE]: z.string().min(1, "This field is required"),
  [MAINTENANCE]: z.string().min(1, "This field is required"),
  [SKU]: z.string().min(1, "This field is required"),
  [NO_OF_WORKSTATIONS]: z.string().min(1, "This field is required"),
  [INCLUDES_BOOKS]: z.string().optional(),
  [SCHOOL_TIER]: z.string().min(1, "This field is required"),
  [SYLLABUS]: z.array(z.string()).min(1, "This field is required"),
  [ACCOUNT_TYPE]: z.string().optional(),
  [STUDENT_STRENGTH]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
